import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_INTERNAL_PEOPLE,
  PATH_INTERNAL_PEOPLE_NEW,
  PATH_INTERNAL_THIRD_PARTIES_DEFAULT,
} from '../../app/constants/paths.constant';
import { FormVariant } from '../../forms';
import { PersonForm } from '../../forms/ThirdParty/Person';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewInternalPersonPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.InternalThirdParties);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'une Personne SOCNA")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_INTERNAL_THIRD_PARTIES_DEFAULT,
            label: 'tiers',
            key: 'internalThirdParties',
          },
          {
            to: PATH_INTERNAL_PEOPLE,
            label: 'personnes',
            key: 'internalPeople',
          },
          {
            to: PATH_INTERNAL_PEOPLE_NEW,
            label: 'nouvelle',
            key: 'internalNewPerson',
          },
        ]}
      />
      <PageTitle title="Création d'une Personne SOCNA" />
      <PersonForm
        formVariant={FormVariant.Creation}
        isInternal
        showCancelButton={false}
      />
    </>
  );
};
